// Convert string to number, handling edge cases
export const toNumber = value => {
  // If already a number, return as is
  if (typeof value === 'number') {
    return value
  }

  // If string, try to parse
  if (typeof value === 'string') {
    const trimmed = value.trim()
    // Empty string becomes 0
    if (trimmed === '') {
      return 0
    }
    const parsed = Number(trimmed)
    return isNaN(parsed) ? 0 : parsed
  }

  // null, undefined, or other types become 0
  return 0
}

// Convert all numeric fields in an object to numbers
export const convertObjectValuesToNumbers = obj => {
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[key] = toNumber(value)
    return acc
  }, {})
}

// Convert nested age percentage structure to numbers
export const convertAgePercentageToNumbers = agePercentage => {
  if (!agePercentage || typeof agePercentage !== 'object') {
    return agePercentage
  }

  return Object.entries(agePercentage).reduce((acc, [ageGroup, values]) => {
    if (typeof values === 'object' && values !== null) {
      acc[ageGroup] = convertObjectValuesToNumbers(values)
    } else {
      acc[ageGroup] = values
    }
    return acc
  }, {})
}

export const preserveNullAndZeroValues = object => {
  // This function is used to keep null or 0 values in the payload
  // (they are rewritten to empty string in formik values, and it leads to incorrect payload when sending to BE)
  return Object.entries(object).reduce((acc, [key, currentValue]) => {
    if (['id', 'data'].includes(key)) {
      return acc
    }

    const originalValue = object.data?.[key]
    const isCurrentValueNumber = !isNaN(Number(currentValue))
    const isOriginalValueNumber = !isNaN(Number(originalValue))

    if (currentValue || currentValue === 0) {
      acc[key] = isCurrentValueNumber ? Number(currentValue) : currentValue
    } else if (!currentValue && originalValue) {
      acc[key] = isOriginalValueNumber ? 0 : ''
    } else if (!currentValue && !originalValue) {
      acc[key] = originalValue
    }

    return acc
  }, {})
}
